import React from 'react'
import styled from 'styled-components'

import KOL_MARK from '@root/shared/assets/brand/kol-mark.png'

import type { ClassNameProps } from '@root/shared/react'

export type LogoGlassProps = {
  size?: number
} & ClassNameProps

/**
 * The kol.trade mark: the pixel blade kol.trade itself shows.
 *
 * A raster, not the vector wave this used to draw, because the mark only
 * exists as one. The name stays so every screen that shows the logo keeps
 * working without being touched.
 */
export const LogoGlass: React.FC<LogoGlassProps> = ({
  size = 128,

  className,
}) => {
  return (
    <Root $width={size} $height={size} className={className}>
      <Mark src={KOL_MARK} alt="kol.trade" draggable={false} />
    </Root>
  )
}

const Root = styled.div<{
  $width: number
  $height: number
}>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Mark = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`
